<template>
  <div id="app">
    <div ref="chatWhatsapp" class="hidden absolute z-60 rounded-full shadow-md w-12 h-12"
      style="right: 8px;bottom: 128px;user-select: none;touch-action: none;"
      @touchstart="dragStart" @touchmove="dragging" @touchend="dragEnd">
      <!-- <a :href="whatsappp" target="_blank"> -->
        <img @click="sendWhatsapp" src="./assets/whatsapp.png" class="w-12 h-12 rounded-full" alt="">
      <!-- </a> -->
    </div>
    <keep-alive >
      <router-view v-if="shouldKeepAlive" @openChat="chatOpen"/>
    </keep-alive>
    <router-view v-if="!shouldKeepAlive" @openChat="chatOpen"/>
  </div>
</template>

<script>
import {
  getId
} from '@/api/user'
import {
  getCategory,
} from "@/api/drop";
import VConsole from 'vconsole';
import {trackMixin} from '@/mixin/track'
  export default {
    mixins: [trackMixin],
    data() {
      return {
        istoken: false,
        manage: {},
        shouldKeepAlive: false,
        whatsappp:'',
        userInfo: {},
        active: false,
        x: 0,
        y: 0,
        screenWidth: 0,
        screenHeight: 0,
      }
    },
    watch: {
      '$route.meta.keepAlive': {
        immediate: true,
        handler(newVal) {
          this.shouldKeepAlive = newVal;
        },
      },
    },
    mounted(){
      getCategory().then((res)=>{
        localStorage.setItem("co_cate", JSON.stringify(res.data));
      })

      this.screenWidth = window.innerWidth - 48;
      this.screenHeight = window.innerHeight - 98;

      if(this.$store.state.user.token){
        this.istoken = true
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if(this.userInfo.id=="1493"){
          const vconsole = new VConsole();
        }
        this.trackSetPeople({'$name': this.userInfo.first_name, '$email':  this.userInfo.email, 'plan' : 'Premium'}, this.userInfo.id)
      }else{
        this.istoken = false
        const tourist = window.localStorage.getItem("Touriststoken")
        if(tourist){
          this.trackSetPeople({'$name': 'Tourist', '$email':  'Tourist', 'plan' : 'Tourist'}, tourist)
        }
      }
      // this.StartWebSocket()
      if(this.istoken){
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if(this.userInfo.hasOwnProperty('manage')){
          this.manage = this.userInfo.manage
          if(this.manage.whatsappp.indexOf('+')==-1){
            this.manage.whatsappp = '+86'+ this.manage.whatsappp
          }
          this.whatsappp ='https://api.whatsapp.com/send?phone='+this.manage.whatsappp+'&text=Hello, '+this.manage.englishname;
        }
      }else{
        if(localStorage.getItem('chat_info')){
          let chatInfo = JSON.parse(localStorage.getItem('chat_info'))
          this.manage = chatInfo.manage
          if(this.manage.whatsappp.indexOf('+')==-1){
            this.manage.whatsappp = '+86'+ this.manage.whatsappp
          }
          this.getwhatsapp()
        }else{
          // let code = localStorage.getItem('invitation_code')
          // getId({
          //   type: 1,
          //   code: code
          // }).then(res=>{
          //   localStorage.setItem('chat_info',JSON.stringify(res.data))
          //   this.manage = res.data.manage
          //   if(this.manage.whatsappp.indexOf('+')==-1){
          //     this.manage.whatsappp = '+86'+ this.manage.whatsappp
          //   }
          //   this.getwhatsapp()
          // })
          this.manage = {
            englishname: "Raymond.zhong",
            id: "76",
            image_url: "https://co-logistics.cn/api/uploads/user_image/76.png?v=1713260086",
            service_email: "raymond@co-logistics.com",
            whatsappp: "+8618026909023"
          }
          this.getwhatsapp()
        }
      }
    },
    methods: {
      getwhatsapp(){
        if(localStorage.getItem('invitation_code')){
          this.whatsappp ='https://api.whatsapp.com/send?phone='+this.manage.whatsappp+'&text=Hello, '+this.manage.englishname;
        }else{
          this.whatsappp ='https://api.whatsapp.com/send?phone=+8618026909023&text=Hello, Cargosoon';
        }
      },
      chatOpen(){
        window.open('https://api.whatsapp.com/send?phone='+this.manage.whatsappp+'&text=Hello, '+this.manage.englishname,"_blank")
      },
      sendWhatsapp(){
        let username = ''
        if(this.istoken){
          username = this.userInfo.first_name + ' '+ this.userInfo.last_name
        }else{
          let chatInfo = JSON.parse(localStorage.getItem('chat_info'))
          username = chatInfo.chat_id
        }
        let pages = this.$route.name
        // if (pages=='cart') {
        //   if(localStorage.getItem('shipping_cart')){
        //     let cartItem = JSON.parse(localStorage.getItem('shipping_cart'))
        //     let num = 0
        //     for(let i=0;i<cartItem.sku_info.length;i++){
        //       num += Number(cartItem.sku_info[i].num)
        //     }
        //     let msg = {
        //       page: 'Cart',
        //       product: cartItem.subject,
        //       qty: num,
        //       link: `https://m.codropshipping.com/productDetail?id=${cartItem.goods_id}&source=${cartItem.source} `,
        //     }
        //     let text = `Customer: ${username} | Source: ${msg.page} | Product: ${msg.product} | Qty: ${msg.qty} | Link: ${msg.link}`
        //     window.open('https://api.whatsapp.com/send?phone='+this.manage.whatsappp+'&text='+encodeURIComponent(text), "_blank")
        //   }else{
        //     this.$toast({
        //       message: 'Please check at least one item',
        //     });
        //   }
        // }else 
        if(pages=='orderDetails'){
          let msg = {
            page: 'Order',
            order: this.$route.query.id,
          }
          let text = `Customer: ${username} | Source: ${msg.page} | Order NO: ${msg.order} `
          window.open('https://api.whatsapp.com/send?phone='+this.manage.whatsappp+'&text='+encodeURIComponent(text), "_blank")
        }else if(pages=='productDetail'){
          let goods = JSON.parse(localStorage.getItem('product_detail'))
          let msg = {
            page: 'Product',
            product: goods.name,
            link: goods.link,
          }
          let text = `Customer: ${username} | Source: ${msg.page} | Product: ${msg.product} | Link: ${msg.link} `
          window.open('https://api.whatsapp.com/send?phone='+this.manage.whatsappp+'&text='+encodeURIComponent(text), "_blank")
        }else{
          window.open('https://api.whatsapp.com/send?phone='+this.manage.whatsappp+'&text=Hello, '+this.manage.englishname,"_blank")
        }
      },
      dragStart(e) {
        this.active = true;
      },
      dragging(e) {
        if (this.active) {
          e.preventDefault();
          this.x = e.touches[0].clientX - 24;
          this.y = e.touches[0].clientY - 24;
          if(this.x<0){
            this.x = 0
          }else if(this.x>this.screenWidth){
            this.x = this.screenWidth
          }
          if(this.y<0){
            this.y = 0
          }else if(this.y>this.screenHeight){
            this.y = this.screenHeight
          }
          this.$nextTick(() => {
            this.$refs.chatWhatsapp.style.left = this.x + 'px'
            this.$refs.chatWhatsapp.style.top = this.y + 'px'
          })
        }
      },
      dragEnd() {
        // if(this.x<0){
        //   this.x = 0
        // }else if(this.x>this.screenWidth){
        //   this.x = this.screenWidth
        // }
        // if(this.y<0){
        //   this.y = 0
        // }else if(this.y>this.screenHeight){
        //   this.y = this.screenHeight
        // }
        // this.$nextTick(() => {
        //   this.$refs.chatWhatsapp.style.left = this.x + 'px'
        //   this.$refs.chatWhatsapp.style.top = this.y + 'px'
        // })
        this.active = false;
      },
    }
  }
</script>

<style lang="postcss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap");

#app {
  font-family: "Inter", "Lato", "Ubuntu", sans-serif;
  background-color:  #f0f1f6;
  -moz-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.input {
  @apply w-full bg-white dark:bg-darkMain border border-inputBorder dark:border-darkMain focus:outline-none focus:ring focus:ring-formRing focus:border-formBorder rounded px-3 py-2 text-base;
  transition: color 0.5s;
}

input[type="date"]{
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
}

.select {
  @apply w-full bg-white dark:bg-darkMain dark:border-darkMain border border-inputBorder focus:outline-none focus:ring focus:ring-formRing focus:border-formBorder rounded px-2 py-2 text-base;
  /* transition: all 0.5s; */
}

::-webkit-scrollbar {
  width: 1px;
  height: 1px;
}

::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: transparent;
}

::-webkit-scrollbar-track {
  border-radius: 0;
  background: transparent;
}
</style>
